export default __webpack_public_path__ + "static/media/Facility-with-open-shift-icon-new.aa0a85ce.svg";